import { useState } from "react"

import UnscheduledTasks from "./Tasks/UnscheduledTasks"
import StageFields from "./Fields/StageFields"
import UpcomingAndOverdueTasks from "./Tasks/UpcomingAndOverdueTasks"

import { useCurrentTLO } from "web/hooks/context"

export default function ActionPanel() {
  const { userCan } = useCurrentTLO()

  const [isSectionOpen, setIsSectionOpen] = useState({
    unscheduledTasks: false,
    overdueAndUpcomingTasks: false,
    fields: true,
  })

  function handleToggleSection(section) {
    setIsSectionOpen({ ...isSectionOpen, [section]: !isSectionOpen[section] })
  }

  const userCanUpdateDeal = userCan("update")

  return (
    <div className="flex flex-col gap-2">
      <UpcomingAndOverdueTasks
        isOpen={isSectionOpen.overdueAndUpcomingTasks}
        onToggle={() => handleToggleSection("overdueAndUpcomingTasks")}
        readOnly={!userCanUpdateDeal}
      />
      <UnscheduledTasks
        isOpen={isSectionOpen.unscheduledTasks}
        onToggle={() => handleToggleSection("unscheduledTasks")}
        readOnly={!userCanUpdateDeal}
      />
      {userCanUpdateDeal && (
        <StageFields
          isOpen={isSectionOpen.fields}
          onToggle={() => handleToggleSection("fields")}
        />
      )}
    </div>
  )
}
